<template>
  <div>
    <div v-if="violato">
      <div class="consigli info">
        <h3>COSA FARE ORA</h3>
        <h5>Non è colpa tua! Ma ora devi correre ai ripari!</h5>
        <h5>Non abbassare mai la guardia!</h5>
        <p>Controlla la tua casella di posta in arrivo, riceverai entro 5 minuti da angelo@difendersidaglihacker.com le istruzioni su come procedere e mettere al sicuro i tuoi dati, la tua persona o la tua azienda da malintenzionati.</p>
        <p>I risultati sopra indicano che i dati in questione si trovano in rete, quindi sbrigati e corri immediatamente ai ripari prima che sia troppo tardi.</p>
        <p>PS: Se non trovi la mail controlla anche nella cartella di posta indesiderata, nella cartella spam, social o promozioni e aggiungi l’indirizzo angelo@difendersidaglihacker.com ai mittenti attendibili o clicca che non è SPAM.</p>
      </div>
      <div class="consigli safety">
        <h3>Basta preoccupazioni, ti avvisiamo noi!</h3>
        <p>Visto il continuo aumentare degli attacchi hacker, per cercare di aiutarti e risolvere il problema legato alle violazioni di siti, app, e-commerce, social, piattaforme varie e di gioco ecc…, abbiamo creato una piattaforma che ti permette di monitorare in tempo reale (o quasi) se anche la tua mail e la tua password vengono coinvolte.</p>
        <p>Non serve che ti ricordi tutte le tue password o quali password sono legate a quale e-mail, tu registri la mail o anche più indirizzi e-mail sulla piattaforma Cybetower Radar e saremo noi ad aiutarti a tenere monitorata la situazione.</p>
        <p>Che tu voglia monitorare la tua mail professionale, privata o entrambe lo potrai fare da un semplice pannello di controllo.</p>
        <p>In poche parole, attivando il monitoraggio del tuo indirizzo e-mail, potrai sapere se verrà nuovamente coinvolto in qualche violazione o inserita in qualche lista.</p>
        <p>Potrai monitorare anche più di una mail alla volta, ad esempio caselle di colleghi o collaboratori, partner di affari oppure quelle della tua famiglia.</p>
        <p>Avrai tutto questo controllo da una singola schermata.</p>
        <p>Nel caso in cui una e-mail monitorata subisce una nuova violazione, verrà inviato un messaggio di avviso appena veniamo a conoscenza della violazione così da poter correre subito ai ripari.</p>
      </div>
    </div>
    <div v-else>
      <div class="consigli info">
        <h3>COSA FARE ORA</h3>
        <h5>Non abbassare mai la guardia!</h5>
        <p>Controlla la tua casella di posta in arrivo, riceverai entro 5 minuti da angelo@difendersidaglihacker.com le istruzioni su come procedere e mettere al sicuro i tuoi dati, la tua persona o la tua azienda da malintenzionati.</p>
        <p>PS: Se non trovi la mail controlla anche nella cartella di posta indesiderata, nella cartella spam, social o promozioni e aggiungi l’indirizzo angelo@difendersidaglihacker.com ai mittenti attendibili o clicca che non è SPAM.</p>
      </div>
      <div class="consigli safety">
        <h3>Ecco come NON dimenticare di controllare… ci pensa RADAR!</h3>
        <p>Visto il continuo aumentare degli attacchi hacker, per cercare di aiutarti e risolvere il problema legato alle violazioni di siti, app, e-commerce, social, piattaforme varie e di gioco ecc…, abbiamo creato una piattaforma che ti permette di monitorare in tempo reale (o quasi) se anche la tua mail e la tua password vengono coinvolte.</p>
        <p>Non serve che ti ricordi tutte le tue password o quali password sono legate a quale e-mail, tu registri la mail o anche più indirizzi e-mail sulla piattaforma Cybetower Radar e saremo noi ad aiutarti a tenere monitorata la situazione.</p>
        <p>Che tu voglia monitorare la tua mail professionale, privata o entrambe lo potrai fare da un semplice pannello di controllo.</p>
        <p>In poche parole, attivando il monitoraggio del tuo indirizzo e-mail, potrai sapere se verrà nuovamente coinvolto in qualche violazione o inserita in qualche lista.</p>
        <p>Potrai monitorare anche più di una mail alla volta, ad esempio caselle di colleghi o collaboratori, partner di affari oppure quelle della tua famiglia.</p>
        <p>Avrai tutto questo controllo da una singola schermata.</p>
        <p>Nel caso in cui una e-mail monitorata subisce una nuova violazione, verrà inviato un messaggio di avviso appena veniamo a conoscenza della violazione così da poter correre subito ai ripari.</p>
      </div>
    </div>
  </div>
  <div class="consigli-landing">
    <img src="@/assets/images/altri/arrows.gif" alt="Arrows" class="arrows">
    <h2 class="mb-4">Al monitoraggio continuo…Ci pensiamo noi!</h2>
    <p>Nel mondo digitale essere veloci fa parte del gioco.</p>
    <p>Venire a conoscenza di una violazione è importante che avvenga nel minor tempo possibile per evitare che i dati rubati vengano utilizzati.</p>
    <p>Più passa il tempo e più gli attacchi hacker sono frequenti e colpiscono qualsiasi persona o azienda, non importa chi tu sia, quanto tu abbia in banca e che tipo di dati tratti. Per loro non sono importanti, per te sì!</p>
    <p>Avere accesso alle tue password permette ad un hacker di accedere ai tuoi dati, per lui capire dove li salvi è solo questione di tempo.</p>
    <p>Una volta entrato sarà molto silenzioso, ti terrà d’occhio ed entrerà in azione quando meno te lo aspetti.</p>
    <p>Magari deviando un bonifico, magari inviando mail a nome tuo.</p>
    <p>Sei anche tu tra quelli che per comodità utilizza la stessa password ovunque?</p>
    <p>Ora visto che so già che non ti metterai mai a controllare ogni singolo account dove usi la stessa password e che solo in caso di furto lo faresti (forse 😊) ecco la soluzione su misura per te!</p>
    <p><b>CYBETOWER® Radar!</b></p>
    <p>La piattaforma di sicurezza che ti permette di registrare la tua e-mail e poterla tenere sotto controllo.</p>
    <p>Il tuo unico sforzo sarà cliccare qui sotto per selezionare l’abbonamento, al resto ci pensa CYBETOWER® Radar!</p>
    <p>Puoi inserire più e-mail da monitorare e avere subito una panoramica della situazione.</p>
    <p>CYBETOWER® Radar eseguirà più volte al giorno il controllo.</p>
    <img src="@/assets/images/altri/screenshot.png" alt="Screenshot">
    <p>Nel caso in cui una e-mail monitorata subisce una nuova violazione, viene inviato un messaggio di avviso appena veniamo a conoscenza della violazione così da poter correre subito ai ripari.</p>
    <img src="@/assets/images/altri/arrows.gif" alt="Arrows" class="arrows">
    <FlipClock :idd="'flipclock1'"></FlipClock>
    <Pacchetti :email="localEmail" :valuta="valutaCode"></Pacchetti>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import FlipClock from "@/components/FlipClock";
import Pacchetti from "@/components/Pacchetti"; // Assumed import path for the Pacchetti component

export default {
  components: {
    FlipClock,
    Pacchetti
  },
  props: {
    violato: {
      type: Boolean,
      required: true,
    },
    valuta: {
      type: String,
      required: false,
      default: 'EUR',
    },
    email: {
      type: String,
      required: true,
    },
    valutaCode: {
      type: String,
      required: false,
      default: 'EUR'
    }
  },
  setup(props) {
    const lifetimeBtn = ref(true);
    const contatore = ref(null);
    const localEmail = ref(props.email);

    console.log("localEmail: ", localEmail.value);

    const Counter = () => {
      let startNumber = Date.now() / 100 - 2200000000;
      window.localStorage.setItem('start', startNumber);

      let text = parseInt(startNumber).toLocaleString(undefined, { minimumFractionDigits: 0 });
      contatore.value = text;

      setInterval(() => {
        try {
          let startNumber = Date.now() / 100 - 2200000000;
          startNumber = parseInt(startNumber) + Math.floor(Math.random() * 12);
          let text = parseInt(startNumber).toLocaleString(undefined, { minimumFractionDigits: 0 });
          contatore.value = text;

          window.localStorage.setItem('start', parseInt(startNumber));
        } catch (error) {
          console.error(error);
        }
      }, 1600);
    };

    const removeLifeTime = () => {
      lifetimeBtn.value = false;
    };

    onMounted(() => {
      Counter();
      const route = useRoute();
      if (typeof route.query.e !== 'undefined') {
        localEmail.value = decodeURI(route.query.e);
      }
    });

    return {
      lifetimeBtn,
      contatore,
      localEmail,
      removeLifeTime,
      FlipClock
    };
  },
};
</script>

<style scoped>
h3 {
  text-align: center;
}

.consigli {
  color: white;
  font-weight: 400;
  background: #333;
  margin: 25px 0;
  overflow: hidden;
  padding: 20px;
  border-radius: 35px 0px 35px 0px;
  -moz-border-radius: 35px 0px 35px 0px;
  -webkit-border-radius: 35px 0px 35px 0px;
}

.consigli.info {
  border: 3px solid rgba(255, 183, 3, 0.9);
}
.consigli.safety {
  border: 3px solid rgba(30, 245, 62, 0.9);
}
.consigli .btn {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  padding: 12px 24px;
  border: 1px solid #a9ae04;
  border-radius: 9px;
  background: #ffff00;
  background: -webkit-gradient(linear, left top, left bottom, from(#ffff00), to(#f5c400));
  background: -moz-linear-gradient(top, #ffff00, #f5c400);
  background: linear-gradient(to bottom, #ffff00, #f5c400);
  -webkit-box-shadow: #ffff07 0px 0px 40px 0px;
  -moz-box-shadow: #ffff07 0px 0px 40px 0px;
  box-shadow: #ffff07 0px 0px 40px 0px;
  text-shadow: #ffff08 1px 1px 1px;
  color: #111111;
  text-decoration: none;
  cursor: pointer;
}
.arrows {
  width: 40%;
  margin-top: 3em;
}
.consigli-landing {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align: center;
}
.consigli-landing img {
  margin: 1em auto;
  margin-top: 3em;
}
</style>
